import React, { useEffect, useRef } from 'react';
import ApexCharts from 'apexcharts';

const ApexChart = ({
  type = 'line',
  height = 300,
  width = '100%',
  options = {},
  series = [],
  className = '',
}) => {
  const containerRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return undefined;

    chartRef.current = new ApexCharts(containerRef.current, {
      ...options,
      chart: {
        ...(options.chart || {}),
        type,
        height,
        width,
      },
      series,
    });

    chartRef.current.render();

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
    // Chart creation should only happen once; updates are handled in the next effect.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!chartRef.current) return;

    chartRef.current.updateOptions(
      {
        ...options,
        chart: {
          ...(options.chart || {}),
          type,
          height,
          width,
        },
      },
      false,
      true
    );

    chartRef.current.updateSeries(series, true);
  }, [type, height, width, options, series]);

  return <div ref={containerRef} className={className} />;
};

export default ApexChart;

